export default "__VITE_ASSET__DR5cIPJi__"